module.exports = __webpack_public_path__ + "img/code-pull-request.a99c9ba4.svg";